import Alpine from 'alpinejs'

Alpine.data('pastAuctions', (products: Array<Object>, language: String, currency: String, listName: String) => ({

    products: products,
    overlayOpen: false,
    overlayProductIndex: null,
    config: {
        language: language,
        currency: currency,
        listName: listName
    },

    init() {
        this.detectProductIdInUrl()
    },

    detectProductIdInUrl() {
        const anchorProductId = window.location.hash.replace('#', '')
        if(anchorProductId.match(/^[0-9]{4}[A-Z]{2}$/)) {
            const productIndex = this.products.findIndex(product => product.productId === anchorProductId)
            if(productIndex >= 0) {
                this.loadOverlay(productIndex)
            }
        }
    },

    trackIntent() {
        const product = this.products[this.overlayProductIndex]
        if(product && product.tracking) {
            try {
                window.gtag('event', 'add_to_cart', {
                    currency: this.config.currency,
                    value: product.tracking.price,
                    items: [ product.tracking ]
                })                
            } catch {}
        }
    },

    loadOverlay(productIndex) {

        const product = this.products[productIndex]
        if(!product || !product.url) {
            return
        }
        this.overlayProductIndex = productIndex

        fetch(product.url, {
            credentials: 'include',
            method: 'POST'
        }).then(response => {
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()
        }).then(data => {

            Alpine.morph(this.$refs.productOverlay.firstChild, data.htmlFragment)
            history.replaceState(undefined, undefined, '#'+product.productId)
            this.overlayOpen = true
            this.$dispatch('modal-open')

            // wishlist store
            Alpine.store('wishlist').setIsOnWishlist(product.productId, data.isOnWishlist)

            // tracking
            
            try {
                if(product.tracking) {
                    window.gtag('event', 'select_item', {
                        item_list_name: this.config.listName,
                        items: [ product.tracking ]
                    })
    
                    window.gtag('event', 'view_item', {
                        currency: this.config.currency,
                        value: product.tracking.price,
                        items: [ product.tracking ]
                    })
                    
                    window.fbq('track', 'ViewContent', {
                        content_ids: [ product.productId ],
                        content_type: 'product',
                        value: product.tracking.price,
                        currency: 'EUR'
                    });
                }
    
                window.algolia.view_product(product.productId)
                
                window.criteo_q.push({ 
                    event: 'viewItem',
                    item: product.productId
                })
                
                window.pintrk('track', 'pagevisit', {
                    product_id: [ product.productId ]
                });
                
            } catch {}

        }).catch(error => {
            console.log(error)
        })
    },

    reloadOverlay() {
        if(this.overlayProductIndex) {
            this.loadOverlay(this.overlayProductIndex)
        }
    },

    closeOverlay() {
        this.overlayProductIndex = null
        this.overlayOpen = false
        this.$dispatch('modal-closed')
        this.$dispatch('product-overlay-closed')
        history.replaceState(undefined, undefined, window.location.pathname + window.location.search)
    },

    prepareProduct(productIndex, game) {

        this.products[productIndex].price = window.elumeo.currency.formatShort(game.productPrice.priceInMCU)
        this.products[productIndex].oldPrice = game.productPrice.originalPriceInMCU ? window.elumeo.currency.formatShort(game.productPrice.originalPriceInMCU) : null
        this.products[productIndex].savingsPercent = game.localisation.price.discount

        this.products[productIndex].name = game.localisation.productDetails.productName
        this.products[productIndex].isAvailable = game.availableVariants.length > 0 && game.productPrice.priceInMCU > 0

        this.products[productIndex].materialClass = ''
        this.products[productIndex].materialName = ''
        if( game.productInfo.materialFamily &&
            game.productInfo.materialFamily !== '' &&
            game.productInfo.materialFamily !== 'N/A' &&
            game.productInfo.materialFamily !== 'OTHER'
        ) {
            this.products[productIndex].materialClass = game.productInfo.materialFamily.toLowerCase()
            this.products[productIndex].materialName = game.localisation.productDetails.materialFamily
        }
        this.products[productIndex].materials = [...new Set(
            game.availableVariants
                .filter(variant => variant.material !== undefined && variant.material !== 'OT')
                .map(variant => variant.material.toLowerCase())
        )]

        const ringSizes = [...new Set(
            game.localisation.variants
                .filter(variant => variant.ringSize !== undefined)
                .map(variant => variant.ringSize)
                .sort()
        )]

        // flags

        this.products[productIndex].flags = {
            any: false
        }

        if(game.tags) {
            for(const tag of game.tags) {
                if( tag.text === 'new' ||
                    tag.text === 'oneItem' ||
                    tag.text === 'discount'
                ) {
                    this.products[productIndex].flags[tag.text] = true
                    this.products[productIndex].flags.any = true
                }
            }
        }

        // keep first and last size

        this.products[productIndex].ringSizes = []
        if(ringSizes.length > 0) {
            this.products[productIndex].ringSizes.push(ringSizes.shift())
        }
        if(ringSizes.length > 0) {
            this.products[productIndex].ringSizes.push(ringSizes.pop())
        }

        return this.products[productIndex]
    },

    loadProducts(indexBegin, numberOfProducts, trackingOffset) {

        const productsSection = this.products.slice(indexBegin, indexBegin+numberOfProducts)
        const productIds = productsSection.map(product => product.productId)

        if(productIds.length === 0) {
            return
        }

        const url = 'https://api.juwelo.de/api/no-auth/app/products/'
            + this.config.language
            + '?filter=productIDs:' + productIds.join(',')
            + '&options=includeUnavailable:true;allowZeroPrice:true'

        fetch(url, {
            method: 'GET'
        }).then(response => {
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()
        })
            .then(games => {
                
                const itemsTrackingData = []
                games.forEach(game => {
                    const productIndex = productsSection.findIndex(product => product.productId === game.productBase.productId)
                    if(productIndex < 0) {
                        return
                    }
                    const product = this.prepareProduct(indexBegin+productIndex, game)
                    product.tracking = window.ga4.prepare_game_item(
                        game,
                        trackingOffset+productIndex+1,
                        this.config.language,
                        this.config.currency,
                        this.config.listName
                    )
                    itemsTrackingData.push(product.tracking)
                })
                return itemsTrackingData
                
            }).then(itemsData => {
                try {
                    window.gtag('event','view_item_list', {
                        item_list_name: this.config.listName,
                        items: itemsData
                    })
                } catch {}
            }).catch(e => {
                console.log(e)
            })
    }

}))